var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "script" } },
      [
        _c(
          "b-modal",
          {
            attrs: {
              visible: true,
              id: "extend-session-modal",
              size: "lg",
              centered: "",
              title: "Soon log out",
              "no-close-on-esc": true,
              "no-close-on-backdrop": true,
              "hide-header-close": true
            },
            on: { hide: _vm.onHide },
            scopedSlots: _vm._u([
              {
                key: "modal-header",
                fn: function() {
                  return [
                    _c(
                      "h2",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "extend-session-modal___BV_modal_title_" }
                      },
                      [_vm._v(_vm._s(_vm.$t("ExtendLogin.ExtendLoginTitle")))]
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "modal-footer",
                fn: function() {
                  return [
                    _c("div", { staticClass: "w-100 centered" }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top.center",
                              value: {
                                content: _vm.$t("ExtendLogin.LogoutTooltip")
                              },
                              expression:
                                "{ content: $t('ExtendLogin.LogoutTooltip') }",
                              modifiers: { top: true, center: true }
                            }
                          ],
                          staticClass: "btn btn-danger",
                          attrs: { type: "button", id: "logoutBtn" },
                          on: { click: _vm.logout }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ExtendLogin.Logout")) +
                              "\n            "
                          ),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(_vm.$t("ExtendLogin.Logout")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-all",
                          attrs: { type: "button", id: "continueLoginBtn" },
                          on: { click: _vm.continueLogin }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ExtendLogin.ContinueLogin")) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ]
                },
                proxy: true
              }
            ])
          },
          [
            _vm._v(" "),
            _c(
              "div",
              { style: { "max-height": _vm.winHeight, overflow: "auto" } },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.loginExpiringBody) + "\n      "
                )
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }